import { rpcClient } from "@/api/WebsocketClient"
import SWR, { Call } from "@/api/SWR"
import { reactive } from "@vue/reactivity"
import SortAndFilterUtil from "@/util/SortAndFilterUtil"
import AddressBook from '@/model/directory/AddressBook';
import Page from '@/model/Page';
import { addressBookStore } from '@/store/AddressBookStore';

export default class GeneratedAddressBookServiceApi {

    cache: Map<string, Call<any>> = new Map<string, Call<any>>()

    constructor() {
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.apis.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    clearState() {
        this.cache = new Map<string, Call<any>>()
    }

    get connected(): boolean {
        return rpcClient.state.connected
    }

    _getAddressBooks(): Promise<AddressBook[]> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('getAddressBooks', rpcParams, true).then((data: any) => {
            if (data && Array.isArray(data)) {
                const addressBooks: AddressBook[] = data.map(addressBook => Object.assign(new AddressBook(), addressBook))
                addressBookStore.replaceAddressBooks(addressBooks)
                return addressBooks
            } else return Promise.reject()
        })
    }


    _createAddressBook(addressBook: AddressBook): Promise<AddressBook[]> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('createAddressBook', rpcParams, false).then((data: any) => {
            if (data && Array.isArray(data)) {
                const addressBooks: AddressBook[] = data.map(addressBook => Object.assign(new AddressBook(), addressBook))
                addressBookStore.addOrReplaceAddressBooks(addressBooks)
                return addressBooks
            } else return Promise.reject()
        })
    }


    _updateAddressBook(addressBook: AddressBook): Promise<string> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('updateAddressBook', rpcParams, false).then((data: any) => {
            const model = Object.assign(new AddressBook(), data)
            addressBookStore.removeAddressBook(addressBook.originalId)
            addressBookStore.addOrReplaceAddressBook(model)
            return model.originalId
        })
    }

    _deleteAddressBook(originalId: string): Promise<void> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('deleteAddressBook', rpcParams, false).then(() => {
            addressBookStore.removeAddressBook(originalId)
        })
    }

    _setAddressbookShares(originalId: string, arg1: any[] | null): Promise<void> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('setAddressbookShares', rpcParams, false) as Promise<void>
    }

    _shareAddressbook(originalId: string, arg1: any[] | null): Promise<void> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('shareAddressbook', rpcParams, false) as Promise<void>
    }

    getAddressBooks(refresh?: boolean | number): SWR<AddressBook[], string[]> {
        //@ts-ignore
        const result: SWR<AddressBook[], string[]> = reactive(new SWR<AddressBook[], string[]>())
        const args: any[] = Array.prototype.slice.call(arguments, 0, 0).filter(arg => arg !== undefined)
        const callId: string = '_getAddressBooks' + JSON.stringify(args)
        const cached: Call<string[]> | undefined = this.cache.get(callId)
        if (refresh === undefined && cached && cached.ended) {
            for (const [ id, call ] of this.cache) {
                if (id.startsWith('_getAddressBooks[') && id !== callId && (!call.ended || call.ended > cached.ended)) {
                    refresh = 3000
                    break
                }
            }
        }
        if (cached && !cached.ended) {
            result.call = cached
            cached.promise?.then((data: string[]) => {
                const addressBooks: AddressBook[] = []
                for (const id of data) {
                    const addressBook: AddressBook | undefined = addressBookStore.state.addressBooks.get(id)
                    if (addressBook) {
                        addressBooks.push(addressBook)
                    }
                }
                result.data = addressBooks
            })
        } else if (refresh !== -1 && (!cached || refresh === true || (typeof refresh === 'number' && (cached.ended || 0) < (Date.now() - refresh)))) {
            const call = reactive(new Call<string[]>()) as Call<string[]>
            this.cache.set(callId, call)
            call.loading = !cached
            call.refreshing = !!cached
            //@ts-ignore since Array.filter does not provide nullsafe guard
            call.promise = this._getAddressBooks().then((data: AddressBook[]) => {
                //@ts-ignore since Array.filter does not provide nullsafe guard
                result.data = data
                //@ts-ignore since Array.filter does not provide nullsafe guard
                call.data = data.map(addressBook => addressBook.originalId || '')
                return call.data
            }).catch(e => {
                setTimeout(() => {
                  this.cache.delete(callId)
                }, 1000)
                return Promise.reject(e)
            }).finally(() => {
                call.ended = Date.now()
                call.loading = false
                call.refreshing = false
            })
            result.call = call
        }
        let addressBooks: AddressBook[] = [...addressBookStore.state.addressBooks.values()]
        
        
        
        result.data = addressBooks
        return result
    }

    getAddressBook(originalId: string): AddressBook | undefined {
        return addressBookStore.state.addressBooks.get(originalId)
    }
}
